import { SystemProps, useBreakpointValue } from '@chakra-ui/react'
import { useSetRecoilState } from 'recoil'

import { lightboxVideoModalState } from 'src/atoms/ui.atom'
import { BrandColor } from 'src/types'

import CustomTooltip from '../CustomTooltip/CustomTooltip'

import Button from './Button/Button'

const VideoTutorialButton: React.FC<
  SystemProps & {
    brandColor: BrandColor
    label?: string
    vimeoUrl: string
    tooltip?: string
  }
> = ({ brandColor, label, vimeoUrl, tooltip, ...props }) => {
  const setVideoModal = useSetRecoilState(lightboxVideoModalState)
  const showVideo: React.MouseEventHandler = (ev) => {
    ev.stopPropagation()
    ev.preventDefault()
    setVideoModal({ vimeoUrl, brandColor })
  }
  const isSmMd = useBreakpointValue({ sm: true, lg: false })
  if (isSmMd === undefined) return null
  if (tooltip && !isSmMd) {
    return (
      <CustomTooltip label={tooltip}>
        <Button
          brandColor={brandColor}
          label={label}
          showVideo={showVideo}
          {...props}
        />
      </CustomTooltip>
    )
  }
  return (
    <Button
      brandColor={brandColor}
      label={label}
      showVideo={showVideo}
      {...props}
    />
  )
}

export default VideoTutorialButton
